import { render } from "./top.vue?vue&type=template&id=2258ce75&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import "./top.vue?vue&type=style&index=0&id=2258ce75&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2258ce75"]])

export default __exports__